module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_plan_show_bg_01-dba2fa344c6b66f93be12ad66c7998a1.jpg";